import {
  Box,
  Button,
  Card,
  CardContent,
  Fade,
  Stack,
  Typography,
} from "@mui/material";
import AppButton from "../../components/button/AppButton";
import AppTextInput from "../../components/inputs/AppTextInput";
import { AppColors } from "../../constants/AppColors";
import { useRegisterScreen } from "./hooks/useRegisterScreen";

const RegisterScreen = () => {
  const vm = useRegisterScreen();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: AppColors.background,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Fade in timeout={350}>
        <Card sx={{ width: "100%", maxWidth: 520, borderRadius: "24px" }}>
          <CardContent sx={{ p: 3 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "18px",
                bgcolor: AppColors.primary,
                color: AppColors.textOnPrimary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                fontWeight: 900,
                fontSize: 24,
              }}
            >
              RP
            </Box>

            <Typography variant="h4" sx={{ fontWeight: 900, mb: 1 }}>
              {vm.t("auth.createAccount")}
            </Typography>

            <Typography color="text.secondary" sx={{ mb: 3 }}>
              {vm.t("auth.registerSubtitle")}
            </Typography>

            {vm.error ? (
              <Typography color="error" sx={{ fontWeight: 700, mb: 1.5 }}>
                {vm.error}
              </Typography>
            ) : null}

            <Box component="form" onSubmit={vm.handleRegister}>
              <AppTextInput
                label={vm.t("auth.accountName")}
                value={vm.accountName}
                onChange={(event) => vm.setAccountName(event.target.value)}
                error={Boolean(vm.getFieldError("account_name"))}
                helperText={vm.getFieldError("account_name")}
                autoComplete="organization"
              />

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <AppTextInput
                  label={vm.t("auth.firstName")}
                  value={vm.firstName}
                  onChange={(event) => vm.setFirstName(event.target.value)}
                  error={Boolean(vm.getFieldError("first_name"))}
                  helperText={vm.getFieldError("first_name")}
                  autoComplete="given-name"
                />

                <AppTextInput
                  label={vm.t("auth.lastName")}
                  value={vm.lastName}
                  onChange={(event) => vm.setLastName(event.target.value)}
                  error={Boolean(vm.getFieldError("last_name"))}
                  helperText={vm.getFieldError("last_name")}
                  autoComplete="family-name"
                />
              </Stack>

              <AppTextInput
                label={vm.t("auth.email")}
                value={vm.email}
                onChange={(event) => vm.setEmail(event.target.value)}
                error={Boolean(vm.getFieldError("email"))}
                helperText={vm.getFieldError("email")}
                autoComplete="email"
              />

              <AppTextInput
                label={vm.t("auth.phone")}
                value={vm.phone}
                onChange={(event) => vm.setPhone(event.target.value)}
                error={Boolean(vm.getFieldError("phone"))}
                helperText={vm.getFieldError("phone")}
                autoComplete="tel"
              />

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <AppTextInput
                  label={vm.t("auth.password")}
                  value={vm.password}
                  onChange={(event) => vm.setPassword(event.target.value)}
                  type="password"
                  error={Boolean(vm.getFieldError("password"))}
                  helperText={vm.getFieldError("password")}
                  autoComplete="new-password"
                />

                <AppTextInput
                  label={vm.t("auth.confirmPassword")}
                  value={vm.passwordConfirmation}
                  onChange={(event) =>
                    vm.setPasswordConfirmation(event.target.value)
                  }
                  type="password"
                  error={Boolean(vm.getFieldError("password_confirmation"))}
                  helperText={vm.getFieldError("password_confirmation")}
                  autoComplete="new-password"
                />
              </Stack>

              <Box sx={{ mt: 2 }}>
                <AppButton
                  title={vm.t("auth.register")}
                  type="submit"
                  loading={vm.loading}
                />
              </Box>
            </Box>

            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary">
                {vm.t("auth.alreadyHaveAccount")}
              </Typography>

              <Button
                variant="text"
                onClick={vm.goToLogin}
                disabled={vm.loading}
              >
                {vm.t("auth.login")}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
};

export default RegisterScreen;
